import React, { useReducer } from 'react'
import { Modal as BSModal } from 'react-bootstrap'


import './AsyncConfirm.scss'
import useTranslation from '@/Hooks/UseTranslation'
import Button from '../Button/Button'
import { useSelector } from 'react-redux'

const AsyncConfirm = () => {
  const { t } = useTranslation()

  const {
    show,
    title,
    message,
    onConfirm,
    isConfirming,
    onDeny,
    isDenying
  } = useSelector((state: any) => state.InterfaceReducer.asyncConfirm)

  return (
    <BSModal
      show={show}
      onHide={onDeny}
      className="async-confirm-modal"
      backdropClassName='async-confirm-backdrop'
      backdrop="static"
      keyboard={false}
      centered
    >
      <BSModal.Header>
        <BSModal.Title>{title}</BSModal.Title>
      </BSModal.Header>
      <BSModal.Body>
        <p className="async-confirm-message">{message}</p>
      </BSModal.Body>
      <BSModal.Footer>
        <div className="async-confirm-buttons">
          <Button
            variant="secondary"
            onClick={onDeny}
            disabled={isConfirming || isDenying}
          >
            {isDenying && (
              <div className="spinner-small spinner-primary" />
            )}
            <span>{t('ASYNC_CONFIRM:DenyButton')}</span>
          </Button>
          <Button
            variant="primary"
            onClick={onConfirm}
            disabled={isConfirming || isDenying}
          >
            {isConfirming && (
              <div className="spinner-small spinner-primary" />
            )}
            <span>{t('ASYNC_CONFIRM:ConfirmButton')}</span>
          </Button>
        </div>
      </BSModal.Footer>
    </BSModal>
  )
}

export default AsyncConfirm
